// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-trade-barometer-v2/form-item-trade-barometer-v2.component.scss
// module id = 1025
// module chunks = 0